import React from 'react';
import PropTypes from 'prop-types';

function ArrowsBorder({ color }) {
  return (
    <>
      <path
        d="M185.135 157.674H198.035C199.599 157.674 200.381 155.785 199.276 154.68L192.826 148.229C192.141 147.545 191.03 147.545 190.346 148.229L183.895 154.68C182.79 155.785 183.573 157.674 185.135 157.674Z"
        fill={color}
      />
      <path
        d="M133.03 222.065V209.165C133.03 207.602 131.141 206.819 130.036 207.925L123.586 214.375C122.901 215.06 122.901 216.17 123.586 216.855L130.036 223.305C131.141 224.41 133.03 223.628 133.03 222.065Z"
        fill={color}
      />
      <path
        d="M196.57 274.212H183.67C182.107 274.212 181.324 276.101 182.429 277.206L188.879 283.656C189.564 284.341 190.675 284.341 191.36 283.656L197.81 277.206C198.915 276.101 198.132 274.212 196.57 274.212Z"
        fill={color}
      />
      <path
        d="M250.141 210.175V223.075C250.141 224.639 252.03 225.421 253.135 224.316L259.585 217.866C260.27 217.181 260.27 216.07 259.585 215.385L253.135 208.935C252.03 207.83 250.141 208.613 250.141 210.175Z"
        fill={color}
      />
    </>
  );
}

ArrowsBorder.propTypes = {
  color: PropTypes.string,
};

ArrowsBorder.defaultProps = {
  color: '#4F535E',
};

export default ArrowsBorder;
